import React, { useCallback, useMemo } from 'react';
import '@/assets/styles/ui-component.less';
import type { IImage, IProduct, IProps } from './IComponent';
import type { IProduct as IProductShare } from '@reolink-deps/reolink_web.fe.shared-modules';
import CategoryBox from './components/CategoryBox';
import ProductCard from './components/ProductCard';
import CommonBox from '@/basic/CommonBox/CommonBox';
import { getProductInfoMapByIds as getReolinkProductInfoMapByIds } from '@/api/reolink/clientApi/store/product';
import { getProductInfoMapByIds as getCamovueProductInfoMapByIds } from '@/api/camovue/clientApi/store/product';
import { ProductPopup } from '@reolink-deps/reolink_web.fe.shared-modules';
import useScreenWidthByUA from '@/utils/hooks/useScreenWidthByUA';
import './index.less';
import { NewLink } from '@/basic/NewLink';

const Recommendations: React.FC<IProps> = (props) => {
    // eslint-disable-next-line react/destructuring-assignment
    const {
        i18nPackage,
        country,
        ctx
    } = props;
    const screenWidth = useScreenWidthByUA(ctx?.headers?.userAgent);

    const getImg = React.useCallback((image: IImage): string => {
        if (screenWidth < 1280) {
            return image.mobile;
        }
        return image.pc;
    }, [screenWidth]);

    const isWebView = useMemo(() => {
        const ua = props.ctx?.headers?.userAgent;
        if (ua?.includes('mobile-android')) return true;
        if (ua?.includes('mobile-iOS')) return true;
        return false;
    }, [props.ctx]);

    const [allProductInfo, setAllProductInfo] = React.useState<Record<number, IProductShare[]>>({});

    const handleProductPrice = useCallback( async () => {
        if (props.allProductId.length) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            let res: any;
            if (__MERCHANT__ === 'camovue') {
                res = await getCamovueProductInfoMapByIds(
                    props.allProductId.map(id => id.toString()), props.lang, props.country);
            }
            else {
                res = await getReolinkProductInfoMapByIds(props.allProductId.map(Number));
            }
            setAllProductInfo(res);
        }
    }, [props.allProductId, props.country, props.lang]);

    React.useEffect(() => {
        // webview环境下不调用
        if (isWebView) return;
        handleProductPrice().catch(err => {
            console.error(err);
        });

    }, [handleProductPrice, isWebView]);

    React.useEffect(() => {
        // webview环境下不调用
        if (isWebView) return;
        ProductPopup.init();
    }, [isWebView]);

    return (
        <CommonBox style={ props.style }>
            <div className={ 'recommend_container' }>
                {
                    props.list.map(category =>
                        (
                            <div
                                key={ category.title }
                                className={ 'recommend_wrap' }
                            >
                                <div className={ 'single_recommend_box' }>
                                    {/* CategoryBox */}
                                    <CategoryBox
                                        name={ category.name }
                                        link={ category.link }
                                        title={ category.title }
                                        description={ category.description }
                                        note={ category.note }
                                        image={ getImg(category.image) }
                                        screenWidth={ screenWidth }
                                        linkText={ props.linkText }
                                        isWebView={ isWebView }
                                    />
                                    {/* ProductBox */}
                                    <div className={ 'recommend_products_box' }>
                                        {
                                            category?.products?.map((product) => {
                                                return (
                                                    product?.id ? (
                                                        <ProductCard
                                                            key={ product.id }
                                                            country={ country }
                                                            getImg={ getImg }
                                                            i18nPackage={ i18nPackage }
                                                            screenWidth={ screenWidth }
                                                            allProductInfo={ allProductInfo }
                                                            product={ product as unknown as IProduct }
                                                            isWebview={ isWebView }
                                                        />
                                                    ) : null
                                                );
                                            }) ?? null
                                        }
                                    </div>
                                    {/* View More */}
                                    {
                                        screenWidth <= 768 ? (
                                            <div style={{ display: 'flex', justifyContent: 'center',  marginTop: '16px' }}>
                                                <NewLink
                                                    href={ category.link }
                                                    text={ props.linkText }
                                                    target={ '_self' }
                                                />
                                            </div>
                                        ) : null
                                    }
                                </div>
                            </div>
                        )
                    )
                }
            </div>
        </CommonBox>
    );
};

export default Recommendations;
